// import JsonFetcher from '../components/layout/JsonFetcher';

// export default class Contact {
//   constructor() {
//     const jsonFetcher = new JsonFetcher(document.querySelector('.json-fetcher'));
//     jsonFetcher.init();
//   }
// }
